import idb from '@/store/services/idb';
import { WsCalls } from '@/store/services/wsCalls';

// initial state
const state = () => ({
  itens: [],
  post: [],
  delete: [],
  loadingCart: true,
  modifiedShoppingCart: 0,
  analytics: {
    add: [],
    remove: [],
  }
})

// getters
const getters = {
  getItens: (state) => {
    return state.itens;
  },
  getItensCart: (state) => {
    var cart = [];
    var families = [];
    state.itens.forEach(element => {
      if(element.cart.amount > 0){
        let total = 0;
        let amount = element.cart.amount;
        if (element.cart.type_unit == 0 && element.is_kg == 1 && element.cfg != null && element.cfg.net_weight > 0) {
          amount = parseFloat(amount) * parseFloat(element.cfg.net_weight);
        }
        if(element.offer != null){
          if((element.offer.is_offer_club == 0 && element.offer.dh_activated != null) || element.offer.is_offer_club == 1){
            if(element.offer.is_offer_family == 0){
              if(element.offer.is_offer_unlimited == 0 && element.offer.amount_connect < amount){
                total = element.offer.offer_connect * element.offer.amount_connect;
                total += element.offer.offer_price * (amount - element.offer.amount_connect);
              } else {
                total = element.offer.offer_connect * amount;
              }
            } else {
              if(element.offer.is_offer_unlimited == 1){
                total = element.offer.offer_connect * amount;
              } else {
                let family = families.find(f => f.offer_id == element.offer.offer_id);
                let limite = element.offer.amount_connect - (family == undefined ? 0 : family.qtde);
                if(limite >= amount){
                  total = element.offer.offer_connect * amount;
                } else {
                  if(limite > 0){
                    total = element.offer.offer_connect * limite;
                    total += element.offer.offer_price * (amount - limite);
                  } else {
                    total = element.offer.offer_price * amount;
                  }
                }
                if(family == undefined){
                  family = {
                    offer_id: element.offer.offer_id,
                    qtde: amount
                  };
                  families.push(family);
                } else {
                  family.qtde += amount;
                }
              }
            }
          } else {
            total = element.offer.offer_price * amount;
          }
        } else {
          total = element.price * amount;
        }
        element.total = total;
        const cat = cart.find(c => c.catid == element.catid);
        if(cat){
          cat.itens.push(element);
          cat.total += total;
          cat.qtd += 1;
        } else {
          cart.push({
            catid: element.catid,
            itens: [element],
            total: total,
            qtd: 1
          });
        }
      }
    });
    return cart;
  },
  getItemById: (state) => (sku) => {
    return state.itens.find(p => p.sku == sku);
  },
  getTotalCart: (state) => {
    return state.itens.length;
  },
  getTotalFamily: (state) => (offer_id) => {
    let total = 0;
    let family = state.itens.filter(p => p.offer != null && p.offer.offer_id == offer_id);
    if(family != undefined){
      family.forEach(element => {
        total += element.cart.amount;
      });
    }
    return total;
  },
  getTotalValueCart: (state) => {
    let total = 0;
    var families = [];
    state.itens.forEach(element => {
      let amount = element.cart.amount;
      if (element.cart.type_unit == 0 && element.is_kg == 1 && element.cfg != null && element.cfg.net_weight > 0) {
        amount = parseFloat(amount) * parseFloat(element.cfg.net_weight);
      }
      if(element.offer != null){
        if(element.offer.dh_activated != null){
          if(element.offer.is_offer_family == 0){
            if(element.offer.is_offer_unlimited == 0 && element.offer.amount_connect < amount){
              total += element.offer.offer_connect * element.offer.amount_connect;
              total += element.offer.offer_price * (amount - element.offer.amount_connect);
            } else {
              total += element.offer.offer_connect * amount;
            }
          } else {
            if(element.offer.is_offer_unlimited == 1){
              total += element.offer.offer_connect * amount;
            } else {
              let family = families.find(f => f.offer_id == element.offer.offer_id);
              let limite = element.offer.amount_connect - (family == undefined ? 0 : family.qtde);
              if(limite >= amount){
                total += element.offer.offer_connect * amount;
              } else {
                if(limite > 0){
                  total += element.offer.offer_connect * limite;
                  total += element.offer.offer_price * (amount - limite);
                } else {
                  total += element.offer.offer_price * amount;
                }
              }
              if(family == undefined){
                family = {
                  offer_id: element.offer.offer_id,
                  qtde: amount
                };
                families.push(family);
              } else {
                family.qtde += amount;
              }
            }
          }
        } else {
          total += element.offer.offer_price * amount;
        }
      } else {
        total += element.price * amount;
      }
    });
    return parseFloat(total).toFixed(2);
  },
  getTotalCashback: (state) => {
    var total = 0;
    state.itens.forEach(element => {
      total += element.cart.amount * element.cashback;
    });
    return total;
  },
  getQtdeTotal: (state) => {
    var total = 0;
    state.itens.forEach(element => {
      total += element.cart.amount;
    });
    return total;
  }
}

// actions
const actions = {
  async loadItensCart ({ commit, dispatch, rootGetters }) {
    return new Promise((resolve) => {
      WsCalls.callMethodWS('GET', 'currentOrder', rootGetters['main/getConfig']).then(function (response) {
        if (response.data.cod == 100 && response.data.return != null) {
          commit('setItensCart', response.data.return.items);
          dispatch('order/updateTotalFinal', null, { root: true }).then(function(){
            commit('setLoadingCart', false);
            commit('setModifiedShoppingCart', response.data.return.modified_shopping_cart);
            resolve(true);
          });
        } else {
          commit('clearCart');
          dispatch('order/updateTotalFinal', null, { root: true }).then(function(){
            commit('setLoadingCart', false);
            resolve(true);
          });
        }
      });
    })
  },
  loadItensCartOffline({ commit, dispatch }, itens){
    let cart = [];
    itens.forEach(element => {
      cart.push(element.data);
    });
    commit('setItensCart', cart);
    commit('setLoadingCart', false);
    dispatch('order/updateTotalFinal', null, { root: true });
  },
  updateItemCart({ commit, dispatch }, { item, qtd, kgund }){
    commit('updateItemCart', { item: item, qtd: qtd, kgund: kgund ? 1 : 0 });
    dispatch('order/updateTotalFinal', null, { root: true });
  },
  clearCart({ commit, dispatch }){
    commit('clearCart');
    dispatch('sendCart').then(function(){
      dispatch('order/updateTotalFinal', null, { root: true });
    });
  },
  async sendCart ({ state, dispatch }) {
    return new Promise((resolve) => {
      if(state.post.length == 0 && state.delete.length == 0){
        resolve(true);
      } else {
        dispatch('configEnvioProdutos').then(function(retorno){
          dispatch('sendPost').then(function(response){
              retorno = response == false ? response : retorno;
              if(retorno){
                dispatch('sendDelete').then(function(response){
                  retorno = response == false ? response : retorno;
                  resolve(retorno);
                });
              } else {
                resolve(retorno);
              }
          });
        });
      }
    });
  },
  configEnvioProdutos ({ commit, state }) {
    var itensAddAnalytics = [];
    var valueAddAnalytics = 0;
    var itensRemoveAnalytics = [];
    var valueRemoveAnalytics = 0;
    
    state.analytics.remove.forEach(function (item) {
      if(item.offer != null){ // Quando é oferta
        var nameExclusive = item.offer.cluster_id > 0 ? "Oferta Exclusiva": "Oferta";
        var offerExclusive = item.offer.cluster_id > 0 ? "oe": "o";
        var nameOffer = item.offer.is_offer_club == 0 ? " (Ative e Pague)": " (Preço Clube)";
        var codeOffer = item.offer.is_offer_club == 0 ? "ap": "pc";
        let price = item.offer.dh_activated != null && item.offer.offer_connect > 0 ? item.offer.offer_connect : item.offer.offer_price;
        itensRemoveAnalytics.push({
          "item_id": item.sku,
          "item_name": item.name,
          "price": price,
          "quantity": item.cart.amount,
          "promotion_id": offerExclusive + codeOffer + "-" + item.sku,
          "promotion_name": nameExclusive + nameOffer,
        });
        valueRemoveAnalytics += item.cart.amount * price;
      } else { // Quando não tem oferta
        itensRemoveAnalytics.push({
          "item_id": item.sku,
          "item_name": item.name,
          "price": item.price,
          "quantity": item.cart.amount,
          "promotion_id": "p-" + item.sku,
          "promotion_name": "Produto",
        });
        valueRemoveAnalytics += item.cart.amount * item.price;
      }
    });
    state.analytics.add.forEach(function (item) { // Quando aumenta a quantidade
      if(item.offer != null){ // Quando é oferta
        var nameExclusive = item.offer.cluster_id > 0 ? "Oferta Exclusiva": "Oferta";
        var offerExclusive = item.offer.cluster_id > 0 ? "oe": "o";
        var nameOffer = item.offer.is_offer_club == 0 ? " (Ative e Pague)": " (Preço Clube)";
        var codeOffer = item.offer.is_offer_club == 0 ? "ap": "pc";
        let price = item.offer.dh_activated != null && item.offer.offer_connect > 0 ? item.offer.offer_connect : item.offer.offer_price;
        itensAddAnalytics.push({
          "item_id": item.sku,
          "item_name": item.name,
          "price": price,
          "quantity": item.cart.amount,
          "promotion_id": offerExclusive + codeOffer + "-" + item.sku,
          "promotion_name": nameExclusive + nameOffer,
        });
        valueAddAnalytics += item.cart.amount * price;
      } else { // Quando não tem oferta
        itensAddAnalytics.push({
          "item_id": item.sku,
          "item_name": item.name,
          "price": item.price,
          "quantity": item.cart.amount,
          "promotion_id": "p-" + item.sku,
          "promotion_name": "Produto",
        });
        valueAddAnalytics += item.cart.amount * item.price;
      }
    });
    commit('clearAnalytics');
    return {
      "itensAddAnalytics": itensAddAnalytics,
      "valueAddAnalytics": valueAddAnalytics,
      "itensRemoveAnalytics": itensRemoveAnalytics,
      "valueRemoveAnalytics": valueRemoveAnalytics,
    };
  },
  async clearCartOffline({ dispatch, rootGetters }, isu){
    return new Promise(async (resolve) => {
      WsCalls.callMethodWS('DELETE', 'clearCart', rootGetters['main/getConfig']).then(function () {
        dispatch('sendOfflineCart').then(function(){
          dispatch('loadItensCart', isu).then(function () {
            resolve(true);
          });
        });
      });
    });
  },
  async sendOfflineCart({ getters, rootGetters }) {
    return new Promise(async (resolve) => {
      let itens = await idb.getData('cart');
      itens = itens.filter(p => p.data.store == rootGetters['main/getConfig'].store);
      let cart = [];
      itens.forEach(element => {
        cart.push(element.data.cart);
      });
      WsCalls.callMethodWS('POST', 'currentOrder', rootGetters['main/getConfig'], { items: cart, total: parseFloat(getters.getTotalValueCart) }).then(async function (response) {
        if (response.data.cod == 200) {
          await idb.resetDataTable('cart');
          resolve(true);
        } else {
          resolve(false);
        }
      });
    });
  },
  async sendPost({ commit, state, getters, rootGetters }){
    return new Promise(async (resolve) => {
      if(state.post.length > 0){
        if(rootGetters['user/getIsu'] > 0){
          WsCalls.callMethodWS('POST', 'currentOrder', rootGetters['main/getConfig'], { items: state.post, total: parseFloat(getters.getTotalValueCart) }).then(function (response) {
            if (response.data.cod == 200) {
              commit('clearPost');
              resolve(true);
            } else {
              resolve(false);
            }
          }).catch(() => {
            resolve(false);
          });
        } else {
          state.post.forEach(async element => {
            let item = state.itens.find(i => i.sku == element.sku);
            item.cart = element;
            item.store = rootGetters['main/getConfig'].store;
            await idb.loadData('cart', {
              "sku" : element.sku,
              "data": item
            });
          });
          commit('clearPost');
          resolve(true);
        }
      } else {
        resolve(true);
      }
    });
  },
  async sendDelete({ commit, state, getters, rootGetters }){
    return new Promise((resolve) => {
      if(state.delete.length > 0){
        if(rootGetters['user/getIsu'] > 0){
          WsCalls.callMethodWS('DELETE', 'currentOrder', rootGetters['main/getConfig'], { skus: state.delete, total: parseFloat(getters.getTotalValueCart) }).then(function (response) {
            if (response.data.cod == 300) {
              commit('clearDelete');
              resolve(true);
            } else {
              resolve(false);
            }
          }).catch(() => {
            resolve(false);
          });
        } else {
          state.delete.forEach(async element => {
            await idb.deleteData('cart', element);
          });
          commit('clearDelete');
          resolve(true);
        }
      } else {
        resolve(true);
      }
    });
  },
  async updateItemObs({ commit, getters, rootGetters }, item){
    return new Promise(async (resolve) => {
      if(rootGetters['user/getIsu'] > 0){
        WsCalls.callMethodWS('PATCH', 'currentOrder', rootGetters['main/getConfig'], { items: [item], total: parseFloat(getters.getTotalValueCart) }).then(function (response) {
          if (response.data.cod == 200) {
            commit('updateItemObs', item);
          }
          resolve(response.data);
        });
      } else {
        let itens = await idb.getData('cart');
        console.log(itens);
        let product = itens.find(p => p.data.store == rootGetters['main/getConfig'].store && p.sku == item.sku);
        product.data.cart.obs = item.obs;
        await idb.deleteData('cart', item.sku);
        await idb.loadData('cart', {
          "sku" : product.sku,
          "data": product.data
        });
        commit('updateItemObs', item);
        resolve({ cod: "200", msg: "Sucesso ao atualizar produto no pedido corrente." });
      }
    });
  },
  removeAllFamily({ commit, state, dispatch }, offer_id){
    let family = state.itens.filter(p => p.offer != null && p.offer.offer_id == offer_id);
    if(family != undefined){
      family.forEach(element => {
        commit('updateItemCart', { item: element, qtd: 0 });
      });
      dispatch('order/updateTotalFinal', null, { root: true });
    }
  },
  activeClub({ state, dispatch }){
    state.itens.forEach(element => {
      if(element.offer != null && element.offer.is_offer_club == 1 && element.offer.dh_activated == null){
        dispatch('products/connectActivate', element, { root: true });
      }
    });
  },
  clearModifiedShoppingCart({ commit }){
    commit('setModifiedShoppingCart', 0);
  }
}

// mutations
const mutations = {
  setItensCart (state, itens) {
    state.itens = itens;
  },
  updateItemObs (state, item) {
    const product = state.itens.find(i => i.sku == item.sku);
    if(product){
      product.cart.obs = item.obs;
    }
  },
  updateItemCart (state, { item, qtd, kgund }) {
    if(qtd > 0){
      const product = state.itens.find(i => i.sku == item.sku);
      if(product){
        product.cart.amount = qtd;
        product.cart.type_unit = kgund;
      } else {
        item.cart = {
          amount: qtd,
          type_unit: kgund
        }
        state.itens.push(item);
      }
      state.delete = state.delete.splice(state.delete.indexOf(item.sku), 1);
      state.post = state.post.filter(i => i.sku != item.sku);
      state.post.push({
        sku: item.sku,
        offer_id: item.offer != null ? item.offer.offer_id : 0,
        type_unit: kgund,
        amount: qtd
      });
      state.analytics.remove = state.analytics.remove.filter(i => i.sku != item.sku);
      state.analytics.add = state.analytics.add.filter(i => i.sku != item.sku);
      state.analytics.add.push(product ? product : item);
    } else {
      state.itens = state.itens.filter(i => i.sku != item.sku);
      state.post = state.post.filter(i => i.sku != item.sku);
      state.delete.push(item.sku);
      state.analytics.add = state.analytics.add.filter(i => i.sku != item.sku);
      state.analytics.remove = state.analytics.remove.filter(i => i.sku != item.sku);
      state.analytics.remove.push(item);
    }
  },
  clearCart (state) {
    state.post = [];
    state.itens.forEach(element => {
      state.delete.push(element.sku);
    });
    state.itens = [];
  },
  clearPost (state) {
    state.post = [];
  },
  clearDelete (state) {
    state.delete = [];
  },
  clearAnalytics (state) {
    state.analytics.add = [];
    state.analytics.remove = [];
  },
  setLoadingCart (state, status) {
    state.loadingCart = status;
  },
  setModifiedShoppingCart (state, value) {
    state.modifiedShoppingCart = value;
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}